'use client';

type ReaderProgressBarProps = {
  value: number;
};

export function ReaderProgressBar({ value }: ReaderProgressBarProps) {
  const clamped = Math.min(100, Math.max(0, value));
  const rounded = Math.round(clamped);

  return (
    <div
      className="pointer-events-none absolute inset-x-0 top-0 z-[45] h-[3px] overflow-hidden bg-transparent"
      role="progressbar"
      aria-label="Прогресс текущей главы"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={rounded}
      aria-valuetext={`${rounded}%`}
    >
      <div
        className="h-full w-full origin-left bg-[linear-gradient(90deg,#ff3dae_0%,#ff74c1_100%)] shadow-[0_0_8px_rgba(255,61,174,0.55)] will-change-transform contrast-more:shadow-none"
        style={{ transform: `scaleX(${clamped / 100})` }}
      />
    </div>
  );
}
